import React from 'react';
import TooltipInfo from '../../common/docs/TooltipInfo';
import {
  DS_AIRTABLE,
  DS_DATABASE,
  DS_FIREBASE_CLOUD_FIRESTOE,
  DS_FIREBASE_FUNCTION,
  DS_FIREBASE_REALTIME_DATABASE,
  DS_GOOGLE_SHEET,
  DS_REST_API,
  EMAIL_SERVICE_PLUGIN_API,
  GET_ITEM_ID_FROM_API,
  SMS_SERVICE_PLUGIN_API,
} from '../../common/utils/event_constants';
import {
  AIRTABLE,
  DATABASE,
  FIREBASE_CLOUD_FIRESTORE,
  FIREBASE_FUNCTION,
  FIREBASE_REALTIME_DATABASE,
  GOOGLE_SHEET,
  REST_API,
  SNIPPET_TYPES,
} from 'drapcode-constant';

export const CUSTOM_MODAL_SEPARATOR = '!@#$#@!';

export const getDirectionLinkText = (args) => {
  let labelText = '';
  switch (args.optionsType) {
    case 'pageApi':
      labelText = 'Create Page';
      break;
    case 'refreshPageApi':
    case 'showComponentPageApi':
    case 'hideComponentPageApi':
      labelText = 'Create Page';
      break;
    case 'userRoleApi':
      labelText = 'Create Role';
      break;
    case 'agreementTemplateApi':
    case 'emailTemplateApi':
      labelText = 'Create Template';
      break;
    case 'pageComponent':
      break;
    case 'refreshPageComponent':
      break;
    case 'showPageComponents':
    case 'hidePageComponents':
      break;
    case 'modalApi':
      break;
    case 'dsRestApi':
    case 'dsDatabase':
    case 'dsGoogleSheet':
    case 'dsAirtable':
    case 'dsFirebaseCloudFirestore':
    case 'dsFirebaseFunction':
    case 'dsFirebaseRealtimeDatabase':
      labelText = 'Create Data Source';
      break;
    case 'dsExternalApi':
      labelText = 'Create External API';
      break;
    case 'collectionApi':
      labelText = 'Create Collection';
      break;
    case 'collectionRequestApi':
      break;
  }
  return labelText;
};

export const getFieldDescriptionText = (args, action) => {
  let labelText = '';
  switch (args.optionsType) {
    case 'pageApi':
      if (action.name === 'logoutUser')
        labelText = 'Select a page you want users to land after logout.';
      else if (action.name === 'goToPage') labelText = 'Select the page you want users to land on.';
      else if (action.name === 'switchUserTenant')
        labelText = 'Select the page you want user to land on after switching the tenant.';
      else if (
        [
          'generateEmailOTP',
          'generateSmsOTP',
          'generateUserConsentEmailOTP',
          'generateUserConsentSmsOTP',
          'generateOnlyEmailOTP',
          'generateOnlySMSOTP',
          'generateOnlyUserConsentEmailOTP',
          'generateOnlyUserConsentSmsOTP',
        ].includes(action.name)
      ) {
        labelText = 'Select the page you want users to land for verifying the OTP.';
      } else if (action.name === 'showConfirmationMessage') {
        labelText = 'Select a page you want user to land after canceling the confirmation message.';
      } else if (['verifyUserConsentEmailOTP', 'verifyUserConsentSmsOTP'].includes(action.name)) {
        if (args.name === 'successRedirectUrl') {
          labelText = 'Select a page you want users to land after verifying the OTP.';
        } else if (args.name === 'errorRedirectUrl') {
          labelText = 'Select a page you want users to land after failing to verify the OTP.';
        }
      } else if (action.name === 'createConsentRequest') {
        labelText = 'Select a page you want users to land after giving consent.';
      } else if (action.name === 'signzyDigitalDocSign') {
        if (args.name === 'successRedirectUrl') {
          labelText = 'Select a page you want users to land after signing the document.';
        } else if (args.name === 'failureRedirectUrl') {
          labelText = 'Select a page you want users to land after failing to sign the document.';
        }
      } else if (action.name === 'initiateGoogleCalendarAuth') {
        labelText = getSuccessErrorRedirectUrlLabelTexts(args, 'Google Calendar');
      } else if (action.name === 'initiateGoogleMeetAuth') {
        labelText = getSuccessErrorRedirectUrlLabelTexts(args, 'Google Meet');
      } else if (action.name === 'initiateDocusign') {
        labelText = getSuccessErrorRedirectUrlLabelTexts(args, 'DocuSign');
      } else if (action.name === 'initiateZoomAuth') {
        labelText = getSuccessErrorRedirectUrlLabelTexts(args, 'Zoom');
      } else if (action.name === 'initiateBoxAuth') {
        labelText = getSuccessErrorRedirectUrlLabelTexts(args, 'Box');
      } else labelText = 'Select a page you want users to land after signing up.';
      break;
    case 'refreshPageApi':
      if (action.name === 'sendResetPasswordEmail')
        labelText = 'Select a page where you have added the password reset email form.';
      if (action.name === 'sendEmail') labelText = 'Select a page where you have added form.';
      if (action.name === 'resetNewPassword')
        labelText = 'Select a page where you have added the password reset form.';
      if (action.name === 'refreshSection')
        labelText = 'Select a page that contains the element on which you want to apply the event.';
      break;
    case 'showComponentPageApi':
    case 'hideComponentPageApi':
      labelText = 'Select a page that contains the element on which you want to apply the event.';
      break;
    case 'userRoleApi':
      if (action && action.name && action.name === 'addUserToTenant') {
        labelText =
          "Select a user role you want to assign to new user (if given user doesn't exist).";
      } else {
        labelText = 'Select a sign up user role, previously created.';
      }
      break;
    case 'agreementTemplateApi':
    case 'emailTemplateApi':
    case 'smsTemplateApi':
      labelText = 'Select a template you want to send via this event.';
      break;
    case 'resetPassowordPageComponent':
      if (action.name === 'sendResetPasswordEmail')
        labelText = 'Select the password reset email form.';
      if (action.name === 'resetNewPassword') labelText = 'Select the password reset  form.';
      if (action.name === 'sendEmail') labelText = 'Select the form which have email field.';
      break;
    case 'pageComponent':
      if (action.name === 'sendResetPasswordEmail' || action.name === 'sendEmail')
        labelText = 'Select the email address input field.';
      if (action.name === 'resetNewPassword' && args.name === 'confirmPassword')
        labelText = 'Select the confirm password input field.';
      if (action.name === 'resetNewPassword' && args.name === 'password')
        labelText = 'Select the  password input field.';
      break;
    case 'refreshPageComponent':
    case 'showPageComponents':
    case 'hidePageComponents':
      labelText = 'Select the page component on which you want to apply the event.';
      break;
    case 'pageFormComponents':
      labelText = 'Select the form component on which you want to apply the event.';
      break;
    case 'modalApi':
      labelText = 'Select a modal (from Snippets) that you want to show using this event.';
      break;
    case 'dsRestApi':
      labelText = 'Select a REST API data source that previously you’ve created.';
      break;
    case 'dsDatabase':
      labelText = 'Select a Database data source that previously you’ve created.';
      break;
    case 'dsGoogleSheet':
      labelText = 'Select a Google Sheet data source that previously you’ve created.';
      break;
    case 'dsAirtable':
      labelText = 'Select an Airtable data source that previously you’ve created.';
      break;
    case 'dsFirebaseCloudFirestore':
      labelText = 'Select a Firebase Realtime Database data source that previously you’ve created.';
      break;
    case 'dsFirebaseFunction':
      labelText = 'Select a Firebase Function data source that previously you’ve created.';
      break;
    case 'dsFirebaseRealtimeDatabase':
      labelText = 'Select a Firebase Cloud Firestore data that previously you’ve created.';
      break;
    case 'dsExternalApi':
      labelText = 'Select a External API that previously you’ve created.';
      break;
    case 'collectionApi':
      if (
        [
          'dependentDropDownPopulateOnChange',
          'pdfToText',
          'amazonTextract',
          'customTermsAnonymization',
          'nlpAnonymization',
        ].includes(action.name)
      ) {
        labelText = 'Select a collection from which you want to get data.';
      } else if (action.name === 'saveCollectionAssets') {
        labelText = 'Select a collection in which you want to store the Assets';
      } else if (action.name === 'updateCollectionAssets') {
        labelText = 'Select a collection in which you want to update the Assets';
      } else if (['generatePdfFromSnippet', 'generatePdfFromSection'].includes(action.name)) {
        labelText = 'Select a collection in which you want to store the PDF.';
      } else if (
        [
          'verifyUserConsentEmailOTP',
          'generateUserConsentEmailOTP',
          'generateUserConsentSmsOTP',
          'verifyUserConsentSmsOTP',
          'generateOnlyUserConsentEmailOTP',
          'generateOnlyUserConsentSmsOTP',
        ].includes(action.name)
      ) {
        labelText = 'Select a collection in which you want to save the data.';
      } else if (['saveItemInMetaDataTable', 'mapAllDataInMetaDataTable'].includes(action.name)) {
        labelText =
          args.name === 'metaDataCollection'
            ? 'Select Meta Data Collection in which you want to save the data.'
            : 'Select Target Collection of which you want to map the data.';
      } else if (action.name === 'updateItemInMetaDataTable') {
        labelText =
          args.name === 'metaDataCollection'
            ? 'Select Meta Data Collection in which you want to update the data.'
            : 'Select Target Collection of which you want to map the data.';
      } else if (action.name === 'deleteItemInMetaDataTable') {
        labelText =
          args.name === 'metaDataCollection'
            ? 'Select Meta Data Collection from which you want to delete the data.'
            : 'Select Target Collection of which you want to map the data.';
      } else if (action.name === 'signzyDigitalDocSign') {
        labelText = 'Select a collection from which you want to send document for eSign.';
      } else if (action.name === 'deleteGoogleCalendarEvent') {
        labelText = 'Select a collection from which you want to delete Google Calendar Event.';
      } else if (action.name === 'scheduleGoogleCalendarEvent') {
        labelText =
          'Select a collection from which you want to schedule the Google Calendar Event.';
      } else if (action.name === 'createInstantGoogleMeet') {
        labelText = 'Select a collection from which you want to create the Google Meet.';
      } else if (action.name === 'updateGoogleCalendarEvent') {
        labelText = 'Select a collection from which you want to update the Google Calendar Event.';
      } else if (action.name === 'addDataKnowledgeBase') {
        labelText = 'Select a collection from which you want to send document in Knowledge Base';
      } else if (action.name === 'queryFromKnowledgeBase') {
        labelText =
          'Select a collection from which you want to send your query to knowledge base  ';
        if (args.name === 'collectionForFileField') {
          labelText = 'Select collection for query on specific file (optional)';
        }
      } else if (action.name === 'queryFromTypesense') {
        labelText = 'Select a collection from which you want to send your query to Typesense ';
      } else if (action.name === 'answerFromChatbot') {
        if (args.name === 'collectionForQuery') {
          labelText =
            'Select a collection from which you want to send your query and context  to AI';
        } else {
          labelText = 'Select a collection from which you save your prompt and  answer from AI';
        }
      } else if (action.name === 'createInstantZoomMeet') {
        labelText = 'Select a collection from which you want to create the Zoom Meet.';
      } else if (action.name === 'cibilConsumerReport') {
        labelText = 'Select a collection from which you want to fetch CIBIL Report & Score.';
      } else if (action.name === 'uploadFileToBox') {
        labelText = 'Select a collection from which you want to upload file to Box.';
      } else if (action.name === 'generateQR') {
        labelText = 'Select a collection from which you want to generate QR.';
      } else if (['initiateMPesaC2BPayment', 'initiateMPesaB2CPayout'].includes(action.name)) {
        labelText = 'Select a collection from which you want to initiate M-Pesa payment.';
      } else if (action.name === 'iprsKenya') {
        labelText = 'Select a collection from which you want to fetch IPRS Data';
      } else if (action.name === 'metropolCreditReport') {
        labelText = 'Select a collection from which you want to fetch Metropol Credit Report Data';
      } else if (action.name === 'kraPinChecker') {
        labelText = 'Select a collection from which you want to check KRA PIN Details';
      } else if (action.name === 'eStatementAnalysis') {
        labelText = 'Select a collection from which you want to analyze bank statement';
      } else if (action.name === 'boldSignSendDocument') {
        labelText = 'Select a collection from which you want to send document for signature.';
      } else if (action.name === 'boldSignDocumentStatus') {
        labelText = 'Select a collection from which you want to get document signing status.';
      } else if (action.name === 'FileViewerOpen') {
        labelText = 'Select the collection for the File viewer ';
      } else if (action.name === 'boldSignEmbeddedRequest') {
        labelText =
          'Select a collection from which you want to create an embedded signature request.';
      } else {
        labelText = 'Select a collection from which you want to delete data.';
      }
      break;
    case 'collectionRequestApi':
      labelText = 'Select the type of users to whom you allow adding new data to a collection.';
      break;
    case 'provider':
      labelText = 'Select a provider you want users to use to login/sign up';
      break;
    case 'refreshPageComponentPosition':
      labelText =
        'Choose whether you want new data entry to appear at the beginning or bottom after section refreshes';
      break;
    case 'waitTimeOptionsInSecond':
      labelText = 'Wait time before call reload data.';
      break;
    case 'multiTenantApi':
      if (action.name === 'addUserToTenant') {
        labelText = 'Select the Tenant in which you want to add a user.';
      } else if (action.name === 'removeUserFromTenant') {
        labelText = 'Select the Tenant from where you want to remove a user.';
      }
      break;
    case 'otpAuthenticationType':
      labelText = 'Select the authentication type you want.';
      break;
    case 'dataOperationType':
      labelText = 'Select the operation type you want to perform.';
      break;
    case 'collectionFieldApi':
      if (action.name === 'generateUserConsentEmailOTP') {
        labelText = `Select the user's email field to send the OTP for user consent verification.`;
      } else if (action.name === 'generateUserConsentSmsOTP') {
        labelText = `Select the user's phone number field to send the OTP for user consent verification.`;
      } else if (action.name === 'createConsentRequest') {
        labelText = `Select the user's phone number field to generate the consent request.`;
      } else if (action.name === 'signzyDigitalDocSign') {
        if (args.name === 'secondPartyNameField') {
          labelText =
            'Select the field containing the name of the second party to be included in the document.';
        } else if (args.name === 'considerationPriceField') {
          labelText = 'Select the field containing the consideration price for the document.';
        } else if (args.name === 'stateCode') {
          labelText = 'Select the field containing State Code.';
        } else if (args.name === 'articleCode') {
          labelText = 'Select the field containing Article Code.';
        } else if (args.name === 'stampDutyValue') {
          labelText = 'Select the field containing Stamp Duty Value.';
        } else if (args.name === 'purposeOfStampDuty') {
          labelText = 'Select the field containing Purpose of Stamp Duty.';
        } else if (args.name === 'mergeLimit') {
          labelText = 'Select the field containing Merge Limit.';
        } else if (args.name === 'pdfSaveField') {
          labelText = 'Select the field to save unsigned PDF URL.';
        } else labelText = 'Select the PDF field to sign the document.';
      } else if (
        ['fetchGoogleCalendarEvents', 'syncGoogleCalendarEvents'].includes(action.name) ||
        (action.name === 'scheduleGoogleCalendarEvent' && args.name === 'userIdentifierField')
      ) {
        if (args.name === 'eventIdField') {
          labelText = 'Select the field containing the Google Calendar Event ID.';
        } else {
          labelText =
            'Select the user identifier field to add User reference to Google Calendar events.';
        }
      } else if (
        [
          'scheduleGoogleCalendarEvent',
          'createInstantGoogleMeet',
          'createInstantZoomMeet',
          'updateGoogleCalendarEvent',
        ].includes(action.name)
      ) {
        if (args.name === 'summaryField') {
          labelText = 'Select the Meeting Title field to name the Event.';
        } else if (args.name === 'descriptionField') {
          labelText = 'Select the Meeting Description field to describe the Event.';
        } else if (args.name === 'startTimeField') {
          labelText = 'Select the Start Time field to schedule the Google Calendar Event.';
        } else if (args.name === 'attendeesField') {
          labelText = 'Select the Attendees field to invite people to the Google Calendar Event.';
        } else if (args.name === 'hostField') {
          labelText = 'Select the Host UUID field to assign the host of the Google Calendar Event.';
        } else if (args.name === 'durationField') {
          labelText = 'Select the Duration field to set duration of the Google Calendar Event.';
        } else if (args.name === 'eventIdField') {
          labelText = 'Select the Event ID field to update the Google Calendar Event.';
        }
      } else if (action.name === 'deleteGoogleCalendarEvent') {
        labelText = 'Select the Event ID field to delete the Google Calendar Event.';
      } else if (action.name === 'addDataKnowledgeBase') {
        if (args.name === 'fieldForDoc') {
          labelText = 'Select the Document field to upload In knowledge Base';
        }
      } else if (action.name === 'queryFromKnowledgeBase') {
        if (args.name === 'fieldForQuery') {
          labelText = 'Select the source field for query to knowledge base';
        } else if (args.name === 'fieldForContext') {
          labelText = 'Select the destination field for answer from knowledge base';
        } else if (args.name === 'fieldForFile') {
          labelText = 'Select the source field for File for knowledgeBase (optional)';
        }
      } else if (action.name === 'queryFromTypesense') {
        if (args.name === 'fieldForQuery') {
          labelText = 'Select the source field for query to Typesense';
        }
        if (args.name === 'fieldForContext') {
          labelText = 'Select the destination field for results from Typesense';
        }
        if (args.name === 'collectionOfTypesense') {
          labelText = 'Select the collection to get data from Typesense';
        }
      } else if (action.name === 'answerFromChatbot') {
        if (args.name === 'fieldForQuery') {
          labelText = 'Select the Query field to send to AI';
        } else if (args.name === 'fieldForContext') {
          labelText = 'Select context of knowledge base  field to send  to  AI';
        } else if (args.name === 'fieldForQueryContext') {
          labelText = 'Select the field where query and context will be stored to send to AI';
        } else if (args.name === 'fieldForAnswer') {
          labelText = 'Select the destination field for answer from AI';
        }
      } else if (action.name === 'cibilConsumerReport') {
        if (args.name === 'firstNameField') {
          labelText = 'Select the First Name field to fetch CIBIL Report & Score';
        } else if (args.name === 'middleNameField') {
          labelText = 'Select the Middle Name field to fetch CIBIL Report & Score';
        } else if (args.name === 'lastNameField') {
          labelText = 'Select the Last Name field to fetch CIBIL Report & Score';
        } else if (args.name === 'birthDateField') {
          labelText = 'Select the Birth Date field to fetch CIBIL Report & Score';
        } else if (args.name === 'genderField') {
          labelText = 'Select the Gender field to fetch CIBIL Report & Score';
        } else if (args.name === 'panNumberField') {
          labelText = 'Select the PAN Number field to fetch CIBIL Report & Score';
        } else if (args.name === 'telephoneNumberField') {
          labelText = 'Select the Telephone Number field to fetch CIBIL Report & Score';
        } else if (args.name === 'lineOneField') {
          labelText = 'Select the Address Line One field to fetch CIBIL Report & Score';
        } else if (args.name === 'lineTwoField') {
          labelText = 'Select the Address Line Two field to fetch CIBIL Report & Score';
        } else if (args.name === 'stateField') {
          labelText = 'Select the State field to fetch CIBIL Report & Score';
        } else if (args.name === 'pinCodeField') {
          labelText = 'Select the Pin Code field to fetch CIBIL Report & Score';
        } else if (args.name === 'saveResponseField') {
          labelText = 'Select the field where you want to save the CIBIL response';
        }
      } else if (action.name === 'FileViewerOpen') {
        if (args.name === 'collectionRequest') {
          labelText = 'Select the field of file to open in PDF viewer';
        }
      } else if (action.name === 'uploadFileToBox') {
        if (args.name === 'fileField') {
          labelText = 'Select the File field to upload to Box';
        } else if (args.name === 'folderField') {
          labelText =
            'Select the Folder Path field to upload to Box. Use "/" to indicate nested folders (e.g., "Projects/Marketing/Assets").';
        }
      } else if (action.name === 'generateQR') {
        if (args.name === 'dataField') {
          labelText =
            'Select the field whose value will be used to generate and embed in the QR or barcode.';
        } else if (args.name === 'saveQRField') {
          labelText = 'Select the field to save the generated QR or Barcode.';
        }
      } else if (['initiateMPesaC2BPayment', 'initiateMPesaB2CPayout'].includes(action.name)) {
        if (args.name === 'phoneNumberField') {
          labelText = 'Select the field containing the customer’s phone number for the payment.';
        } else if (args.name === 'amountField') {
          labelText = 'Select the field containing the payment amount to be charged.';
        } else if (args.name === 'occasionField') {
          labelText = 'Select the field containing the occasion or purpose of the transaction.';
        } else if (args.name === 'mPesaReferenceField') {
          labelText = getCustomReferenceLabelText('M-Pesa Callback Response');
        }
      } else if (['iprsKenya', 'metropolCreditReport'].includes(action.name)) {
        if (args.name === 'identifierField') {
          labelText = 'Select the field containing the Kenyan ID number to fetch the data.';
        } else if (args.name === 'loanAmountField') {
          labelText = 'Select the field containing the loan amount.';
        } else if (args.name === 'metropolCreditReportReferenceField') {
          labelText = getCustomReferenceLabelText('Metropol Credit Report');
        } else if (args.name === 'iprsReferenceField') {
          labelText = getCustomReferenceLabelText('IPRS Kenya Data');
        }
      } else if (action.name === 'kraPinChecker') {
        if (args.name === 'kraReferenceField') {
          labelText = getCustomReferenceLabelText('KRA Pin Checks');
        } else labelText = 'Select the field containing the KRA PIN to check its details.';
      } else if (action.name === 'eStatementAnalysis') {
        if (args.name === 'statementField') {
          labelText = 'Select the field containing the bank statement to be analyzed.';
        } else if (args.name === 'decrypterField') {
          labelText = 'Select the field containing the password to decrypt the bank statement.';
        } else if (args.name === 'eStatementReferenceField') {
          labelText = getCustomReferenceLabelText('E-Statement Analysis');
        } else if (args.name === 'bankField') {
          labelText =
            'Select the field containing the bank name for the bank statement to be analyzed.';
        }
      } else if (action.name === 'boldSignDocumentStatus') {
        if (args.name === 'documentFileField') {
          labelText = 'Select the field where you want to save the signed document file.';
        } else labelText = 'Select the field containing Document ID.';
      } else if (['boldSignSendDocument', 'boldSignEmbeddedRequest'].includes(action.name)) {
        if (args.name === 'pdfField') {
          labelText = 'Select the PDF field to send document for signature.';
        } else if (args.name === 'nameField') {
          labelText = 'Select the Name field to assign the signer name for signature.';
        } else if (args.name === 'boldSignEmailField') {
          labelText = 'Select the Email field to assign the signer email for signature.';
        } else if (args.name === 'documentReferenceField') {
          labelText = 'Select the field where you want to store the document reference.';
        } else if (args.name === 'boldSignPhoneNumberField') {
          labelText =
            'Select the Phone Number field to assign the signer phone number for signature.';
        } else if (args.name === 'languageField') {
          labelText =
            'Select the language field to assign the document language using locale codes (e.g. EN, ES, ZH_CN) (Optional) (Default is EN).';
        } else if (args.name === 'urlSaveField') {
          labelText =
            'Select the field where you want to save the request URL for embedded signature request.';
        } else if (args.name === 'titleField') {
          labelText = 'Select the Title field to assign the title for signature .';
        }
      } else if (action.name === 'fetchFinancialInformation') {
        labelText = 'Select the Field to save the asynchronous transaction fetch status.';
      }
      break;
    case EMAIL_SERVICE_PLUGIN_API:
      labelText = 'Select the service from which you want to send the email.';
      break;
    case GET_ITEM_ID_FROM_API:
      if (['showModal', 'displaySubPage', 'openFloatingModal'].includes(action.name)) {
        labelText = 'Select Item ID of the Modal/Subpage Item.';
      } else if (['fetchFinancialInformation', 'fetchContractDetails'].includes(action.name)) {
        if (args.name === 'getRequestIdFrom') labelText = 'Select Request ID from.';
        else labelText = 'Select Item ID which you want to store in your field.';
      } else if (action.name === 'fetchDocusignContractDetails') {
        labelText = 'Select the Envelope ID to retrieve contract details.';
      } else if (action.name === 'fetchDocusignSigningStatus') {
        labelText = `Select the Envelope ID to retrieve signer's signing status.`;
      } else if (
        ['generateUserConsentSmsOTP', 'generateUserConsentEmailOTP'].includes(action.name)
      ) {
        labelText = 'Select the User ID to send the OTP for user consent verification.';
      } else if (action.name === 'createConsentRequest') {
        labelText = 'Select the User ID to create consent request.';
      } else if (
        ['generateOnlyUserConsentSmsOTP', 'generateOnlyUserConsentEmailOTP'].includes(action.name)
      ) {
        labelText = 'Select Item ID for Update Case';
      } else if (['verifyUserConsentSmsOTP', 'verifyUserConsentEmailOTP'].includes(action.name)) {
        labelText = 'Select Item ID (if OTP token missing)';
      } else labelText = 'Select Item ID of the Collection Item.';
      break;
    case 'consentType':
      labelText = 'Select the consent type you want.';
      break;
    case 'getRequestIdFrom':
      labelText = 'Select the request ID to be used for fetching FI data.';
      break;
    case 'getContractIdFrom':
      labelText = 'Select the contract ID to be used for fetching Contract Details.';
      break;
    case 'signaturePositionApi':
      labelText = 'Select the position where you want to place the signature on the document.';
      break;
    case 'smsTypeApi':
      labelText = 'Select the SMS Type you want to send via Parken.';
      break;
    case 'signerIdentifierFieldApi':
      labelText =
        'Select the Signer Identifier Field from Digital Document Signing Signers collection';
      break;
    case 'signerIdentifierValueFromApi':
      labelText = 'Select the source of the value used to match signers';
      break;
    case 'googleCalendarCollectionApi':
      labelText = 'Select a collection to store Google Calendar events.';
      break;
    case 'conferenceProviderApi':
      labelText = 'Select a conference provider you want to use for the meeting.';
      break;
    case 'contractsFieldApi':
      labelText = getCustomReferenceLabelText('Contracts');
      break;
    case 'accountHolderFieldApi':
      labelText = getCustomReferenceLabelText('Account Holders');
      break;
    case 'fiTransactionsFieldApi':
      labelText = getCustomReferenceLabelText('FI Transactions');
      break;
    case 'fetchEventsTillApi':
      labelText = 'Select how far into the future you want to fetch Google Calendar events.';
      break;
    case SMS_SERVICE_PLUGIN_API:
      labelText = 'Select the service from which you want to send the SMS.';
      break;
    case 'codeTypeApi':
      labelText = 'Select the code type you want to generate.';
      break;
    case 'transactionType':
      labelText = 'Select the transaction type.';
      break;
    case 'reportType':
      labelText = 'Select the type of report you want to fetch.';
      break;
    case 'statementType':
      labelText = 'Select the type of bank statement you want to analyze.';
      break;
    case 'boldSignDeliveryMethod':
      labelText = 'Select the delivery method to send the document for signature.';
      break;
    case 'defacementLocationType':
      labelText = 'Select the defacement location.';
      break;
  }
  return labelText;
};

export const getFieldDescriptionTextByName = (args, action) => {
  let labelText = '';
  switch (args.name) {
    case 'enableResetForm':
      labelText =
        'Disabled (by default) to reset parent form component. Enable it to target the specific form component.';
      break;
    case 'enableSubmitForm':
      labelText =
        'Disabled (by default) to submit parent form component. Enable it to target the specific form component.';
      break;
    case 'overrideResetWaitTime':
      labelText = '(Optional) Wait before resetting a form on page load. (Default: 500 ms)';
      break;
    case 'overrideSubmitWaitTime':
      labelText = '(Optional) Wait before submitting a form on page load. (Default: 500 ms)';
      break;
    case 'confirmationMessage':
      labelText = '(Optional) A custom confirmation alert message to display on a popup.';
      break;
    case 'confirmBtnText':
      labelText = '(Optional) A custom confirm button text. (Default: Proceed)';
      break;
    case 'cancelBtnText':
      labelText = '(Optional) A custom cancel button text. (Default: Cancel)';
      break;
    case 'clearAllResponseData':
      labelText = 'Enable to clear values from the session: previousActionResponse';
      break;
    case 'clearAllFormData':
      labelText = 'Enable to clear values from the session: previousActionFormData';
      break;
    case 'clearResponseSelectedKeys':
      labelText =
        'Add single or, multiple comma (,) separated response keys to clear from the session: previousActionResponse';
      break;
    case 'clearFormSelectedKeys':
      labelText =
        'Add single or, multiple comma (,) separated form data keys to clear from the session: previousActionFormData';
      break;
    case 'successMessage':
      labelText = '(Optional) Enter custom success message.';
      break;
    case 'errorMessage':
      labelText = '(Optional) Enter custom error message.';
      break;
    case 'customSessionKey':
      labelText =
        'A custom JSON key which will store the data in your web browser session storage. (Default: collection_[Collection_Name]';
      break;
    case 'isNonPersistent':
      labelText = 'Enable it to use Non-Persistent Data Field Values. (Default: Disabled)';
      break;
    case 'expiryDays':
      labelText = 'Number of Days Before Signature Request Expires';
      break;
    case 'fontSize':
      labelText = 'Set the font size used for typed signatures.';
      break;
    case 'signatureWidth':
      labelText = `Define the width of the signer’s signature field in pixels.`;
      break;
    case 'signatureHeight':
      labelText = `Define the height of the signer’s signature field in pixels.`;
      break;
    default:
      break;
  }
  return labelText;
};

export const getFieldDescriptionInfoByName = (args, action) => {
  let description = '';
  switch (args.name) {
    case 'sendCurrentObjectID':
      description =
        'Enable it to send the recently created or updated Collection Item ID to the next page.';
      break;
    case 'sendPreviousStepParentCollectionId':
      description =
        "Enable it to send the Collection's Item ID, which was recorded in the previous step, to the next page.";
      break;
    case 'sendCurrentUserId':
      description = 'Enable it to send the Current LoggedIn User ID, to the next page.';
      break;
    case 'isNewTab':
      description = 'Enable it to open the navigated page in the new tab of the browser. ';
      break;
    case 'sendCurrentPageItemId':
      description =
        "Enable it to send the Collection's Item ID from the Current Page URL, to the next page.";
      break;
    case 'skipPageReload':
      description = 'Enable it to skip reloading a page (Default: Page will reload on success).';
      break;
    case 'tenantRoleRedirectionRule':
      description = 'Select the page you want user to land on after switching the tenant.';
      break;
    case 'sendCurrentPageReferenceItemId':
      description = `Enable it to send the Collection's Item ID of Current Page Reference Item`;
      break;
    case 'sendTargetItemID':
      description =
        'Enable it to send the target element (Link/Button) Collection Item ID to the next page.';
      break;
    case 'sendItemIdFrom':
      description = `Select the location from where the Item ID should be used to send to the next page.`;
      break;
    case 'isNonPersistent':
      description = `<b>Enabled</b> - Uses Non-Persistent Data Field Values</br><b>Disabled</b> (Default) - Uses Persistent Data Field Values from DrapCode DB`;
      break;
    case 'saveCompleteAPIResponse':
      description = `<b>Enabled</b> - Save the complete API response to the session storage</br><b>Disabled</b> (Default) - Save only the response data which is required to complete the action.`;
    default:
      break;
  }
  return description ? (
    <TooltipInfo
      title={description}
      headerText={`What's ${args.label}?`}
      showHeader={true}
      showArrow={true}
    />
  ) : (
    ''
  );
};

export const getActiveTab = (optionsType) => {
  switch (optionsType) {
    case DS_REST_API:
      return REST_API;
    case DS_AIRTABLE:
      return AIRTABLE;
    case DS_DATABASE:
      return DATABASE;
    case DS_GOOGLE_SHEET:
      return GOOGLE_SHEET;
    case DS_FIREBASE_CLOUD_FIRESTOE:
      return FIREBASE_CLOUD_FIRESTORE;
    case DS_FIREBASE_FUNCTION:
      return FIREBASE_FUNCTION;
    case DS_FIREBASE_REALTIME_DATABASE:
      return FIREBASE_REALTIME_DATABASE;
  }
};

export const validateSubmitBtn = (values, eventAction) => {
  let isSubmitBtnDisabled = false;
  let hasAllRequiredValues = false;
  let requiredFieldList = [];

  switch (eventAction.name) {
    case 'goToPage':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('destination');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'showModal':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('modal');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'customPageRedirect':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('redirectValueFrom', 'destination');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'system_show_component':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('showComponentPage', 'showComponents');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'system_hide_component':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('hideComponentPage', 'hideComponents');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'deleteCollectionItem':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('collection');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    case 'saveCollection':
    case 'saveCollectionDraft':
      isSubmitBtnDisabled = true;
      requiredFieldList.push('collection');
      hasAllRequiredValues = requiredFieldList.every((fieldname) => values[fieldname]);
      isSubmitBtnDisabled = !hasAllRequiredValues;
      break;
    default:
      break;
  }
  return isSubmitBtnDisabled;
};

export const getActionEnableSchema = (events, eventAction) => {
  const { project } = events ? events : '';
  const { environments } = project ? project : '';
  const { defaultEnabled, enabledEnvironments } = eventAction ? eventAction : '';
  let schema = {};
  if (!defaultEnabled) {
    environments.map((environment) => {
      schema[environment.envType] = !!(
        enabledEnvironments &&
        enabledEnvironments.length &&
        enabledEnvironments.includes(environment.envType)
      );
    });
  } else if (environments && environments.length) {
    environments.map((environment) => {
      schema[environment.envType] = true;
    });
  }
  return schema;
};

export const getSnippetModalOptions = (snippets, modalType = SNIPPET_TYPES.MODAL) => {
  let modalOptions = [];

  if (!snippets || !snippets.length) {
    return modalOptions;
  }
  const modalSnippet = snippets.filter((snippet) => snippet.snippetType === modalType);

  switch (modalType) {
    case SNIPPET_TYPES.FLOATING_MODAL:
      {
        modalSnippet.forEach((snippet) => {
          modalOptions.push({
            value: snippet.uuid,
            label: snippet.name,
          });
        });
      }
      break;

    default:
      {
        modalSnippet.forEach((snippet) => {
          modalOptions.push({
            value: snippet.modalId,
            label: snippet.name,
          });
        });
      }
      break;
  }
  return modalOptions;
};

export const getSuccessErrorRedirectUrlLabelTexts = (args, service) => {
  if (args.name === 'successRedirectUrl') {
    return `Select a page you want users to land after authorizing with ${service}.`;
  } else if (args.name === 'errorRedirectUrl') {
    return `Select a page you want users to land after failing to authorize with ${service}.`;
  }
};

export const getCustomReferenceLabelText = (collectionName) => {
  return `Select the field where you want to store your custom or additional reference in ${collectionName} collection.`;
};
